import React, { useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { Plus } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';

import { AGENDA_CONDITIONS } from '../../constants';
import { OneOnOneSettingsPageReactQueryKeys } from '../../constants/OneOnOneSettingsPageReactQueryKeys';
import { EventTemplateAgendaType } from '../AgendaPoints/services';
import { AddEventModal } from './AddEventModal';

interface Props {}

const Events = (props: Props) => {
  const [isEventModalOpen, setEventModalOpen] = useState(false);
  const queryClient = useQueryClient();

  const alreadyAddedEvents = queryClient.getQueryData<EventTemplateAgendaType>([
    OneOnOneSettingsPageReactQueryKeys.oneOnOneAdminAgenda,
    'EVENT_BASED',
  ]);

  const alreadyAddedEventsKeys = Object.keys(alreadyAddedEvents ?? {});

  const allEvents = Object.keys(AGENDA_CONDITIONS); // this also includes REGULAR event type which is not shown in the UI

  return (
    <>
      <Button
        ml="28px"
        mb="16px"
        StartIcon={Plus}
        variant="outlined"
        mt="24px"
        onClick={() => {
          setEventModalOpen(true);
        }}
        isDisabled={alreadyAddedEventsKeys.length === allEvents.length - 1}
      >
        Add Event
      </Button>
      <AddEventModal
        isOpen={isEventModalOpen}
        onClose={() => {
          setEventModalOpen(false);
        }}
        onSave={() => {
          setEventModalOpen(false);
        }}
      />
    </>
  );
};

export { Events };
